import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyIcon } from 'automation-ui-formula-editor/data-sources/utils/getPropertyIcon';
import FormulaEditorTokenTag from 'automation-ui-formula-editor/formula-editor/FormulaEditorTokenTag';
import TokenDescription from 'automation-ui-formula-editor/formula-editor/TokenDescription';
import { FIELD_DATA, OBJECT_PROPERTY } from 'automation-ui-formula-editor/formula-editor/data-passing/constants/DataSourceOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const FormulaEditorToken = ({
  actionOutputs,
  dataSources,
  fieldName,
  formulaState,
  FormulaTokenDisplay = FormulaEditorTokenTag,
  propertiesByGroup,
  useError = false
}) => {
  const fieldExpressionObject = formulaState.getFieldExpressionObject({
    actionOutputs,
    dataSources,
    fieldName,
    propertiesByGroup
  });
  let label;
  let TooltipContent;
  if ((fieldExpressionObject === null || fieldExpressionObject === void 0 ? void 0 : fieldExpressionObject.fieldType) === OBJECT_PROPERTY && propertiesByGroup) {
    label = fieldExpressionObject.reference.label;
  } else if ((fieldExpressionObject === null || fieldExpressionObject === void 0 ? void 0 : fieldExpressionObject.fieldType) === FIELD_DATA && actionOutputs) {
    const {
      actionOutput,
      name,
      type,
      typeLabel
    } = fieldExpressionObject.reference;
    if (actionOutput && name) {
      label = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.formula-editor.token.actionOutput",
        options: {
          label: typeLabel,
          title: actionOutput.actionTitle
        }
      });
      TooltipContent = () => /*#__PURE__*/_jsx(TokenDescription, {
        label: typeLabel,
        name: name,
        title: actionOutput.actionTitle,
        type: type
      });
    }
  }
  return /*#__PURE__*/_jsx(FormulaTokenDisplay, {
    label: label || fieldName,
    propertyIconName: getPropertyIcon({
      dataProperty: dataSources.get(fieldName)
    }),
    TooltipContent: TooltipContent,
    useError: useError
  });
};
export default FormulaEditorToken;